import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../utils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var _Hero = function _Hero(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    "data-t-id": "components-Hero"
  }, children);
};
export var Hero = compose(enhancedConnect({
  children: PropTypes.node
}), withAutoMetric.Container(function () {
  return {
    name: 'Hero'
  };
}))(_Hero);